// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"69c6faa5","388":"e00d54b3","433":"4aafba38","798":"e1d000f8","819":"90b1ae5a","878":"c9dee5dd"}[chunkId] + ".chunk.js";
};